import {ProductProvider} from '@/pages/(shared)/products/detail/providers/productProvider';

import ProductDetails from './components/productDetails';

function ProductDetailsPage() {
  return (
    <ProductProvider>
      <ProductDetails />
    </ProductProvider>
  );
}

export default ProductDetailsPage;
